<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{itemCourtier.libelle || itemCourtier.nom+' '+itemCourtier.prenom}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busyGet,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <form class="m-1">
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                        <label>Filiale :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Code"
                            autocomplete="off" [(ngModel)]="itemCourtier.code" name="code" autocomplete="off" type="text" />
                    </div>
    
    
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Code:
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Code"
                            autocomplete="off" [(ngModel)]="itemCourtier.code" name="code" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Codification:
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Codification" autocomplete="off"
                            [(ngModel)]="itemCourtier.codification" name="codification" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Type:
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Code"
                            autocomplete="off" [(ngModel)]="itemCourtier.code" name="code" autocomplete="off" type="text" />
                    </div>
                    <div  class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Libellé:
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Libellé" autocomplete="off"
                            [(ngModel)]="itemCourtier.libelle" name="libelle" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Nom :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Nom" autocomplete="off"
                            [(ngModel)]="itemCourtier.nom" name="nom" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Prenom :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Prenom" autocomplete="off"
                            [(ngModel)]="itemCourtier.prenom" name="prenom" autocomplete="off" type="text" />
                    </div>
                    
    
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                        <label>Ville :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Ville"
                            autocomplete="off" [(ngModel)]="itemCourtier.ville_libelle" name="ville_libelle" autocomplete="off" type="text" />
                    </div>
    
    
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Email :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Email" autocomplete="off"
                            [(ngModel)]="itemCourtier.email" name="email" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Boite postale :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Boite postale" autocomplete="off"
                            [(ngModel)]="itemCourtier.boite_postale" name="boite_postale" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Numéro compte bancaire :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Compte bancaire" autocomplete="off"
                            [(ngModel)]="itemCourtier.numero_compte" name="numero_compte" autocomplete="off"
                            type="text" />
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Téléphone :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Téléphone" autocomplete="off"
                            [(ngModel)]="itemCourtier.telephone" name="telephone" autocomplete="off" type="text" mask="00-00-00-00-00" />
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Fax :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Fax" autocomplete="off"
                            [(ngModel)]="itemCourtier.fax" name="fax" autocomplete="off" type="text" mask="00-00-00-00-00" />
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Taux commission" autocomplete="off"
                            [(ngModel)]="itemCourtier.taux_commission" name="taux_commission" autocomplete="off" type="text" mask="separator" />
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Image :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input disabled  class="form-control custom-input" autocomplete="off"
                            name="image" autocomplete="off" type="file" />
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Adresse :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Adresse" autocomplete="off"
                            [(ngModel)]="itemCourtier.adresse" name="adresse" autocomplete="off" type="text" />
                    </div>
                   
                </div>
            </form>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
     

        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>